export default __webpack_public_path__ + "static/media/mecca.4e2d81f1.svg";